import styled from 'styled-components';
import { Divider } from 'antd';

export const CustomDivider = styled(Divider)`
    &.ant-divider-horizontal.ant-divider-with-text {
        color: ${(props) => props.theme.sub};
        border-top-color: ${(props) => props.theme.theadSortIcon};
    }
`;
